<template>
  <div class="merchant-container">
    <div class="side-nav">
      <MerchantSideNav />
      <MenuToggle />
    </div>
    <div class="merchant-body transaction-body">
      <header>
        <MerchantHeader />
      </header>
      <div class="dashboard-content">
        <div class="row mt-5">
          <h3>Settlement Banks</h3>
        </div>
        <div class="row">
          <div class="col-12 col-xl-8 pl-0 mb-4">
            <p class="lead-note">
              Accounts saved here are the destinations you can pay a withdrawal to. You may
              keep up to five; the Primary one is pre-selected on the withdrawal form.
            </p>
            <!-- Merchant banks are the SAME records as the user's (`/v1/banks`), so this is
                 the identical component rather than a second copy that could drift from it. -->
            <BankInfo></BankInfo>
          </div>
          <div class="col-12 col-xl-4 pl-0 mb-4">
            <div class="card-style">
              <span>Before you withdraw</span>
              <ol class="hint-list">
                <li>Add the bank account that should receive your payouts.</li>
                <li>Mark one as <strong>Primary</strong> so it is chosen by default.</li>
                <li>
                  Go to <router-link :to="{ name: 'merchant-withdraw' }">Withdraw</router-link>,
                  pick the account and enter an amount - the fees and the exact amount your
                  bank receives are priced before you confirm.
                </li>
              </ol>
              <p class="muted">
                If you have not registered any account, payouts fall back to the settlement
                account on your merchant KYC.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <MerchantFooter />
    </footer>
  </div>
</template>
<script>
import MerchantHeader from "./MerchantHeader.vue";
import MerchantFooter from "./MerchantFooter.vue";
import MerchantSideNav from "./MerchantSideNav.vue";
import MenuToggle from "./MenuToggle.vue";
import BankInfo from "../../dashboard_components/BankInfo.vue";

export default {
  name: "MerchantBank",
  components: { MerchantHeader, MerchantFooter, MerchantSideNav, MenuToggle, BankInfo },
};
</script>
<style lang="scss" scoped>
.lead-note { color: #6c757d; font-size: 13px; margin-bottom: 14px; }
.hint-list { padding-left: 18px; margin: 10px 0; }
.hint-list li { font-size: 13px; color: #6c757d; margin-bottom: 8px; }
.muted { color: #6c757d; font-size: 12px; margin: 0; }
</style>
